export enum ErrorCodeEnum {
  CCP_PENDING_INVOICE_ORDER_TYPE_NOT_SUPPORTED = 'E2134',
  CCP_UNPAID_INVOICE = 'E2183',
  CCP_INVALID_ORDER_REQUEST_DATA = 'E2002',
  CCP_COUPLING_ERROR = 'E9000',
  CCP_ACCOUNT_MODIFICATION_TXA_SAME_AS_CURRENT_TXA = 'E2123',
}
